<script lang="ts">
	import { PriceLevel } from "../../../../core/schema/PriceLevel";
	import { formatPrice } from "../../../../core/schema/utils/formatPrice.js";
	import { getPriceOfOrder } from "../../../../core/schema/utils/getPriceOfOrder";
	import { getGlobalSettings } from "../../getGlobalSettings";
	import { cartStore } from "../../stores/cart/cartStore";
	import Button from "../Button.svelte";
	import cart from "../../../../core/assets/icons/basket.svg?raw";
	import Icon from "../Icon.svelte";
	import { getPriceOfOrderToPay } from "../../../../core/utils/getPriceOfOrderToPay.js";

	export let hide = false;
	export let isButtonDisabled = false;
	export let buttonText = "Pokračovat v objednávce";

	const { TENANT_LOCALE } = getGlobalSettings();

	$: price = getPriceOfOrder($cartStore.value.order, PriceLevel.Basic);
	$: ({ priceOfOrderToPay } = getPriceOfOrderToPay({ ...$cartStore.value.order, price }));
</script>

<div
	class="pointer-events-none fixed bottom-0 left-0 right-0 z-40 h-[7.5rem] transition-[bottom,transform] sm:h-[6.5rem]"
	class:-bottom-full={price.totalPrice.withTax === 0}
	class:bottom-0={price.totalPrice.withTax > 0}
	class:translate-y-full={hide}
>
	<div class="bg-panel-shadow h-[2.25rem]"></div>
	<div
		class="border-secondaryBlack-150 pointer-events-auto flex h-[calc(100%-2.25rem)] flex-col items-center justify-center gap-4 border-t bg-white py-2 sm:flex-row sm:gap-12 lg:gap-16 xl:gap-20"
	>
		<div class="container flex flex-col flex-wrap items-center justify-center gap-1 sm:flex-row sm:gap-4 md:gap-6">
			<div class="flex items-center justify-center gap-4 sm:gap-6 md:gap-10 lg:gap-[2.25rem]">
				<p class="lg:text-md hidden items-center gap-2 text-base font-semibold md:flex">
					<Icon icon={cart} class="h-5" />
					Obsah vaší krabice
				</p>
				<div class="flex items-center gap-4">
					<p class="text-xs lg:text-base">Celkem k úhradě</p>
					<p class="text-md text-right font-bold lg:text-[1.375rem]">
						{formatPrice(priceOfOrderToPay, TENANT_LOCALE, true)}
					</p>
				</div>
			</div>
			<Button type="submit" disabled={isButtonDisabled} variant="primary">
				{buttonText}
			</Button>
		</div>
	</div>
</div>
